export default "__VITE_ASSET__UpXR_hXJ__"